import { Component, OnInit, Output, Inject } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from "@angular/common/http";

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent implements OnInit {

  myRecaptcha: any[];
  @Output() onPassReset = new EventEmitter<boolean>();
  successreset: boolean = false;
  disableReset: boolean = true;
  http: HttpClient;
  baseURL = '';
  data: Object;
  passError: boolean = true;
  passConfirmError: boolean = true;
  captchaValidated: boolean = false;


  param1: string;
  s: ActivatedRoute;
  constructor(@Inject(ActivatedRoute) _activatedRoute: ActivatedRoute, @Inject(HttpClient) http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.http = http;
    this.baseURL = baseUrl;
    this.s = _activatedRoute;
    this.s.queryParams.subscribe(params => {
      this.param1 = params['s'];
    });
  }



  ResetPassword() {
    let password = (document.getElementById("password") as HTMLInputElement).value;
    let confirmPassword = (document.getElementById("confirmpassword") as HTMLInputElement).value;

    this.passConfirmError = true;
    this.passError = true;

    let params = new HttpParams();
    params = params.append('RandomString', this.param1);
    params = params.append('Password', password);

    if (password != '' && confirmPassword != '' && this.captchaValidated == true) {
      console.log("Password resetting");
      this.http.get(this.baseURL + 'api/Login/ResetPassword', { params: params }).subscribe(data => {
        this.data = data;

        if (data) {
          this.successreset = true;
        }
      });
    } else {
      if (confirmPassword == '') {
        this.passConfirmError = false;
      }
      if (password == '') {
        this.passError = false;
      }
    }


  }

  SuccessfulPassReset() {
    this.onPassReset.emit(false);
  }


  resolved(captchaResponse: any[]) {
    this.myRecaptcha = captchaResponse;


    let params = new HttpParams();
    params = params.append('response', this.myRecaptcha.toString());


    this.http.get('api/Captcha/getCaptchaResponse', { params: params }).subscribe(data => {
     
      if (data) {
        //allow reset password
        this.captchaValidated = true;
        this.disableReset = false;
      } else {
        //don't allow password reset
        this.disableReset = true;
        this.captchaValidated = false;
        //display error
      }

    });
  }

  ngOnInit() {
  }

}
